<template>
    <div id="online-payments" class="section alter">
        <h1 class="sub-header">{{ $t("online-payments.header") }}<span class="header-dot">.</span></h1>
        <div class="content">
            <div class="interactive-display">

                <div class="item-list">
                    <div class="item left-side" @mouseenter="messages.block1.message1 = true" @mouseleave="messages.block1.message1 = false">
                        <p class="text">{{ $t("online-payments.list-1.item-1") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/online-payment/card.png" alt="">
                        </div>
                    </div>
                    <div class="item left-side" @mouseenter="messages.block1.message2 = true" @mouseleave="messages.block1.message2 = false">
                        <p class="text">{{ $t("online-payments.list-1.item-2") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/online-payment/chain.png" alt="">
                        </div>
                    </div>
                    <div class="item left-side" @mouseenter="messages.block1.message3 = true" @mouseleave="messages.block1.message3 = false">
                        <p class="text">{{ $t("online-payments.list-1.item-3") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/online-payment/turning-cog.png" alt="">
                        </div>
                    </div>
                    <div class="item left-side" @mouseenter="messages.block1.message4 = true" @mouseleave="messages.block1.message4 = false">
                        <p class="text">{{ $t("online-payments.list-1.item-4") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/online-payment/graph.png" alt="">
                        </div>
                    </div>
                </div>

                <div class="display">
                    <div class="phone-holder">
                        <img class="phone" src="../../../assets/images/props/phone-display.png" alt="">
                        <Transition name="message">
                            <p class="message" v-if="messages.block1.message1">{{ $t("online-payments.phone-messages.message-1") }}</p>
                        </Transition>
                        <Transition name="message">
                            <p class="message" v-if="messages.block1.message2">{{ $t("online-payments.phone-messages.message-2") }}</p>
                        </Transition>
                        <Transition name="message">
                            <p class="message" v-if="messages.block1.message3">{{ $t("online-payments.phone-messages.message-3") }}</p>
                        </Transition>
                        <Transition name="message">
                            <p class="message" v-if="messages.block1.message4">{{ $t("online-payments.phone-messages.message-4") }}</p>
                        </Transition>

                        <Transition name="message">
                            <p class="message" v-if="messages.block2.message1">{{ $t("online-payments.phone-messages.message-5") }}</p>
                        </Transition>
                        <Transition name="message">
                            <p class="message" v-if="messages.block2.message2">{{ $t("online-payments.phone-messages.message-6") }}</p>
                        </Transition>
                        <Transition name="message">
                            <p class="message" v-if="messages.block2.message3">{{ $t("online-payments.phone-messages.message-7") }}</p>
                        </Transition>
                        <Transition name="message">
                            <p class="message" v-if="messages.block2.message4">{{ $t("online-payments.phone-messages.message-8") }}</p>
                        </Transition>
                    </div>
                </div>

                <div class="item-list">
                    <div class="item right-side" @mouseenter="messages.block2.message1 = true" @mouseleave="messages.block2.message1 = false">
                        <p class="text">{{ $t("online-payments.list-2.item-1") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/online-payment/key.png" alt="">
                        </div>
                    </div>
                    <div class="item right-side" @mouseenter="messages.block2.message2 = true" @mouseleave="messages.block2.message2 = false">
                        <p class="text">{{ $t("online-payments.list-2.item-2") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/online-payment/apple.webp" alt="">
                        </div>
                    </div>
                    <div class="item right-side" @mouseenter="messages.block2.message3 = true" @mouseleave="messages.block2.message3 = false">
                        <p class="text">{{ $t("online-payments.list-2.item-3") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/online-payment/google.webp" alt="">
                        </div>
                    </div>
                    <div class="item right-side" @mouseenter="messages.block2.message4 = true" @mouseleave="messages.block2.message4 = false">
                        <p class="text">{{ $t("online-payments.list-2.item-4") }}</p>
                        <div class="icon-holder">
                            <img class="icon" src="../../../assets/images/online-payment/wifi.png" alt="">
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            messages: {
                block1: {
                    message1: false,
                    message2: false,
                    message3: false,
                    message4: false,
                },
                block2: {
                    message1: false,
                    message2: false,
                    message3: false,
                    message4: false,
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#online-payments {
    .content {
        .interactive-display {
            .display {
                // width: 400px;

                .phone-holder {
                    // display: flex;
                    // justify-content: center;
                    // align-items: center;
                    position: relative;
                    // width: 400px;
                    width: 100%;

                    .phone {
                        display: block;
                        // position: absolute;
                        // top: 50%;
                        // left: 50%;
                        // transform: translate(-50%,-50%);
                        margin: 0px auto;
                        width: 400px;
                        // height: 100%;
                    }

                    .message {
                        z-index: 2;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%,-50%);
                        width: 380px;
                        padding: 0px 40px;
                        font-size: 30px;
                        font-size: bold;
                        text-align: center;
                        color: var(--signature);
                    }

                    .message-enter-active {
                        animation: message 0.5s forwards ease-out;
                    }

                    .message-leave-active {
                        animation: message 0.5s forwards ease-out reverse;
                    }

                    @keyframes message {
                        0% {
                            position: absolute;
                            opacity: 0;
                        }
                        100% {
                            position: absolute;
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }
}
</style>